import { Position } from '../../../shared/types/protocol.ts';
import { ProtocolDraft } from '../../types/sharedTypeImpl.ts';
import { getTolerances } from './generalTolerances.ts';


export function onGeneralToleranceChanged(
    protocol: ProtocolDraft,
) {
    if (!protocol.generalTolerance) return;

    for (const position of protocol.positions) {
        if (position.useGeneralTolerance) {
            const tolerances = getTolerances(position.nominal!, protocol.generalTolerance!, position.isChamfer!);
            position.upperTolerance = tolerances?.upperTolerance ?? '';
            position.lowerTolerance = tolerances?.lowerTolerance ?? '';
        }
    }
}

export function onPositionFieldChanged(
    position: Position,
    changedField: keyof Position,
    generalTolerance: string
) {
    const fieldsCauseRecalc: Array<keyof Position> = ['nominal', 'useGeneralTolerance', 'isChamfer'];
    if (!fieldsCauseRecalc.includes(changedField)) {
        return;
    }

    if (position.useGeneralTolerance && fieldsCauseRecalc.includes(changedField)) {
        const tolerances = getTolerances(position.nominal!, generalTolerance, position.isChamfer!);
        position.upperTolerance = tolerances?.upperTolerance ?? '';
        position.lowerTolerance = tolerances?.lowerTolerance ?? '';
    } else if (!position.useGeneralTolerance && changedField === 'useGeneralTolerance') {
        position.upperTolerance = '';
        position.lowerTolerance = '';
    }
}